const initialState = {
    isOpen: false,
    isActive: false,
    title: '',
    message: '',
};
const modalErrorMsg = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_DATA_MODAL_ERROR_MSG':
            return {...state, [action.name]: action.value};
        default:
            return state;
    }
};

export default modalErrorMsg;
